import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import FlexRow from '../../../../components/molecules/FlexRow'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import Icon from '../../../../components/atoms/Icon'
import NavIconButton from './NavIconButton'

const useStyles = makeStyles(theme => ({
  navItem: {
    minWidth: '300px',
    textDecoration: 'none !important',
    transition: 'background-color var(--transition-duration-medium) var(--transition-easing-normal)',
    '&:hover': {
      backgroundColor: 'color-mix(in srgb, var(--color-neutral-900) 25%, transparent)',
      '&.primary': {
        backgroundColor: 'color-mix(in srgb, var(--color-primary-500) 25%, transparent)'
      },
      '&.ai': {
        backgroundColor: 'color-mix(in srgb, var(--color-ai-500) 25%, transparent)'
      }
    },
    '&.primary': {
      color: 'var(--color-primary-500)'
    },
    '&.ai': {
      color: 'var(--color-ai-500)'
    }
  },
  navItemCollapse: {
    textDecoration: 'none !important',
    transition: 'background-color var(--transition-duration-medium) var(--transition-easing-normal)',
    '&.primary': {
      color: 'var(--color-primary-500)'
    },
    '&.ai': {
      color: 'var(--color-ai-500)'
    }
  }
}))

function NavItem ({ to, icon, open, children, className }) {
  const classes = useStyles()

  if (!open) {
    return (
      <Link to={to} className={clsx(classes.navItemCollapse, className)}>
        <FlexRow className='gap-md px-2 py-2 items-center'>
          <FadeIn className='flex items-center'>
            <NavIconButton icon={icon} size={24} />
          </FadeIn>
        </FlexRow>
      </Link>
    )
  }

  return (
    <Link to={to} className={clsx(classes.navItem, className)}>
      <FlexRow className='gap-md px-2 py-2 items-center'>
        <FadeIn className='p-xs flex items-center'>
          <Icon name={icon} customSize={24} />
        </FadeIn>
        {open ? (<FadeIn className='font-size-sm' style={{ lineHeight: '32px' }}>{children}</FadeIn>) : null}
      </FlexRow>
    </Link>
  )
}

NavItem.propTypes = {
  to: PropTypes.string,
  icon: PropTypes.string,
  open: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string
}

export default NavItem
